<div class="loader app-loader proj-add-section" [hidden]="status != STATUS_LOADING">
    <div class="dimmed_outset">
        <core-title-section [title]="'NEW PROJECT'"></core-title-section>
    </div>
  <div class="dimmed">
    <div class="dimmed_table_box dimmed_table_padding">
      <header>
        <div class="dimmed_flex">
          <div class="dimmed_title"></div>
        </div>
      </header>
      <div class="dimmed_data">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_title"></div>
      </div>
      <div class="dimmed_data">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_title"></div>
      </div>
    </div>
  </div>
  <!-- <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading> -->
</div>

<div class="app-wrapper" *ngIf="status == STATUS_DONE && addProjectData != null && access" [ngClass]="{'with-overlay': leavingModal && !savedProject || errorModal || forbiddenErrorModal || generalErrorModal}">
  <core-layout-modal-feedback class="modal-feedback" *ngIf="leavingModal"
        [type]="'warning'"
        [message]="'Discard Project Draft'"
        [text]="'You have not launched your project yet. Are you sure you want to leave and discard your project draft?'"
        [buttonText]="'Discard'"
        [secondButtonText]="'Go Back'"
        (action)="onDiscard($event)"
        (secondButtonAction)="onStay($event)"
    ></core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="errorModal"
        [type]="'fail'"
        [message]="'New Project creation failed'"
        [text]="'You have not launched your project yet. There are some fields you need to review before sent the project.'"
        [buttonText]="'OK'"
        (action)="onDismiss($event)"
    ></core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="forbiddenErrorModal || generalErrorModal"
      [type]="'fail'"
      [message]="'Error'"
      [text]="'The project could NOT be launched. Please contact your admin for additional support.'"
      [buttonText]="'OK'"
      (action)="onDismiss($event)"
  ></core-layout-modal-feedback>
  <nav class="tab_navigation">
    &nbsp;
  </nav>
  <section class="main-content project-add-section">
    <div class="app-main">
      <header >
        <core-title-section
        [title]="'New Project'"
        ></core-title-section>
      </header>
      <div *ngIf="savedProject" class="box_default box_white project-sent">
        <project-add-sent
          [type]="'launched'"
          [message]="'Your project was launched successfully'"
          [firstButtonText]="'OK, TAKE ME TO IT'"
          [secondButtonText]="'I WANT TO LAUNCH ANOTHER ONE'"
          (firstButtonAction)="onOpenProject($event)"
          (secondButtonAction)="onStartNew($event)"
        ></project-add-sent>
      </div>
      <div [hidden]="savedProject || creatingNewProject" class="box_default box_white project-form">
        <header>
          <core-title-section [title]="'Project Details'"></core-title-section>
        </header>
        <article class="project-add-labels project-add-box" [ngClass]="{'add-project-validation-error': errors.labels}">
          <!-- TAGS -->
          <app-helpers-labels-edit-diff-box
            [headerText]="'TAGS FOR THIS NEW PROJECT'"
            [labels]="addProjectData.labels"
            (labelsChange)="onChangeLabels($event)"
          ></app-helpers-labels-edit-diff-box>
          <!-- TAGS -->
        </article >
        <!-- WORKFLOW -->
        <article class="project-add-workflows project-add-box" [ngClass]="{'add-project-validation-error': errors.workflow}">
          <core-helpers-forms-select
          [hidden]="workflowsList.length == 1"
          [optionSelected]="''+addProjectData.workflow"
          [label]="'Select the workflow'"
          [options]="workflowsList"
          (select)="onSelectWorkflow($event)"
          ></core-helpers-forms-select>
        </article >
        <!-- DESCRIPTION -->
        <article class="project-add-info-details project-add-box" [ngClass]="{'add-project-validation-error': errors.info}">
          <label>GENERAL INFORMATION</label>
          <core-helpers-forms-wysiwyg-extended
            [placeholder]="''"
            [modules]="editorModules"
            (textChange)="onInfoChange($event)"
          ></core-helpers-forms-wysiwyg-extended>
        </article >
        <!-- DUE DATE -->
        <article class="project-add-duedate project-add-box" [ngClass]="{'add-project-validation-error': errors.due_date}">
          <project-add-duedate
          [date]="addProjectData.due_date"
          (selectDate)="onSelectDate($event)"
          ></project-add-duedate>
        </article >
        <!-- FILES -->
        <article class="project-attachments-upload project-add-box" [ngClass]="{'add-project-validation-error': errors.files}">
          <app-helpers-add-object-files-upload
            [title]="'ATTACHMENTS'"
            [files]="addProjectData.files"
            (changed)="onSetFiles($event)"
            (uploading)="onUploading($event)"
          ></app-helpers-add-object-files-upload>
        </article >

        <article class="project-original-version project-add-box" [ngClass]="{'add-project-validation-error': errors.version}" *ngIf="version != null">
          <project-add-origin-version
            [version]="version"
          ></project-add-origin-version>
        </article>


        <!-- BUTTONS -->
        <div class="box_fieldset">
          <core-helpers-forms-button-white [disabled]="!isProjectReady() || creatingNewProject" [text]="'Launch Project' " (click)= "onSubmit()"></core-helpers-forms-button-white>
          <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
        </div>
      </div>

      <div [hidden]="!creatingNewProject" class="loader app-loader">
        <core-helpers-box-loading ></core-helpers-box-loading>
      </div>
    </div>
  </section>
</div>
<core-helpers-box-http-error
*ngIf="status == STATUS_NOT_ALLOWED || !access"
[code]="403"
[message]="'Not allowed.'"
></core-helpers-box-http-error>
